import { Skeleton } from '@fs/zion-ui'
import React from 'react'

export default function ResearchHelpTabsSkeleton(): JSX.Element {
  return <Skeleton.Paragraph lineCount={3} size="md" />
}
